import { useNavigate } from 'react-router-dom'
import {
  CarouselWithButtonsVariantOne,
  HeadingAndDescriptionForCWBVO,
} from 'src/consumer/components/ListingPageComponentsAndHelpers/ListingPageComponents'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { SOMYA_ADDICTION_EVENT_URL } from '../../BehavioralAddictionPlan'
import { UIScreenshotsSectionButton } from './styledComponents'

export default function UIScreenshotsDeaddictionPlan({ buttonsOnClick }) {
  const navigate = useNavigate()

  return (
    <CarouselWithButtonsVariantOne
      backgroundColor={'#1C2120'}
      gradientColor="linear-gradient(
      90deg,
      rgba(0, 0, 0, 0) 85%,
      rgba(0, 0, 0, 0.4) 95%,
      rgba(0, 0, 0, 0.9) 100%
    );"
      buttonColor={'#fff'}
      heightProp="550"
      componentOne={
        <HeadingAndDescriptionForCWBVO
          headingText="YOUR HEALING IS OUR TOP PRIORITY"
          descriptionText="With AUMHUM, you are not just another case, you are a valued individual. We're here to support you every step of the way on your journey to a healthier, addiction-free life."
          textColor="#fff"
        />
      }
      // StackComponent={MobileScreenshotComponentForCWBVO}
      StackComponent={MobileScreenshotComponent}
      itemsForStack={[
        'MEDIA-fa7d21b000494723a91e23fc670cdf44',
        'MEDIA-bd92fb364ea3460e97b29c52ac319dea',
        'MEDIA-ad4d69e1046c466c8cee0fdcc9185ad0',
      ]}
      componentTwo={
        <UIScreenshotsSectionButton
          onClick={() => (buttonsOnClick ? buttonsOnClick() : navigate(SOMYA_ADDICTION_EVENT_URL))}
        >
          GET YOUR PLAN
        </UIScreenshotsSectionButton>
      }
    />
  )
}

const MobileScreenshotComponent = ({ data }) => {
  return (
    <img
      src={getImageLink(data)}
      style={{ width: '100%', borderRadius: '10px' }}
      alt="app feature"
    />
  )
}
